import type { FC } from 'react'
import ClockIcon from '../../assets/images/clock_rg_b_48_def.png'
import WarningTriangleIcon from '../../assets/images/warning_triangle.svg'
import { formatConsentReadinessTime } from '../../features/consents/utils/consentReadiness'
import BaseModal from './BaseModal'
import './styles.css'

type VehicleReadinessWarningModalProps = {
  isOpen: boolean
  remainingMs: number
  onCancel: () => void
  onContinue: () => void
}

const VehicleReadinessWarningModal: FC<VehicleReadinessWarningModalProps> = ({
  isOpen,
  remainingMs,
  onCancel,
  onContinue,
}) => {
  const footer = (
    <div className="vehicle-warning-modal-actions">
      <button type="button" className="modal-button modal-button-secondary" onClick={onCancel}>
        Cancel
      </button>
      <button type="button" className="modal-button modal-button-primary" onClick={onContinue}>
        Continue anyway
      </button>
    </div>
  )

  return (
    <BaseModal
      isOpen={isOpen}
      title="Vehicle may not be ready yet"
      titleIcon={
        <img
          src={WarningTriangleIcon}
          alt=""
          aria-hidden="true"
          className="vehicle-warning-modal-icon"
        />
      }
      onClose={onCancel}
      footer={footer}
    >
      <p className="vehicle-warning-modal-text">
        BMW backend services can take up to 5 minutes after consent creation before charging
        steering is available.
      </p>

      <hr className="vehicle-warning-modal-divider" />

      <div className="vehicle-warning-modal-remaining">
        <img src={ClockIcon} alt="" aria-hidden="true" className="vehicle-warning-modal-clock" />
        <span>Remaining time:</span>
        <span className="vehicle-warning-modal-time">
          {formatConsentReadinessTime(remainingMs)}
        </span>
      </div>

      <p className="vehicle-warning-modal-text vehicle-warning-modal-text-secondary">
        You can continue anyway, but testing may fail until the countdown is complete.
      </p>
    </BaseModal>
  )
}

export default VehicleReadinessWarningModal
